import script from "./TicketFeatured.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketFeatured.vue?vue&type=script&setup=true&lang=js"

import "./TicketFeatured.vue?vue&type=style&index=0&id=03911b5f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03911b5f"]])

export default __exports__